import React from 'react';
import { FadeIn } from './FadeIn';
import { Users, Target, HeartPulse, Leaf, Clock, Smile } from 'lucide-react';
export function WhyJoinUs() {
  const benefits = [{
    icon: <Users className="w-8 h-8" data-id="element-369" />,
    title: 'Expert Instructors',
    description: 'Learn from highly qualified and experienced yoga practitioners dedicated to your growth.'
  }, {
    icon: <Target className="w-8 h-8" data-id="element-370" />,
    title: 'Personalized Attention',
    description: 'Small batch sizes ensure you receive individual guidance and posture correction.'
  }, {
    icon: <HeartPulse className="w-8 h-8" data-id="element-371" />,
    title: 'All Levels Welcome',
    description: "Whether you're a beginner or advanced yogi, our classes adapt to your capability."
  }, {
    icon: <Leaf className="w-8 h-8" data-id="element-372" />,
    title: 'Holistic Wellness',
    description: 'Focus on physical strength, mental clarity, and spiritual balance simultaneously.'
  }, {
    icon: <Clock className="w-8 h-8" data-id="element-373" />,
    title: 'Flexible Timings',
    description: 'Morning and evening batches designed to fit seamlessly into your busy schedule.'
  }, {
    icon: <Smile className="w-8 h-8" data-id="element-374" />,
    title: 'Community Support',
    description: 'Join a welcoming, positive community that motivates and uplifts each other.'
  }];
  const stats = [{
    value: '500+',
    label: 'Happy Students'
  }, {
    value: '10+',
    label: 'Years Experience'
  }, {
    value: '4.9',
    label: 'Google Rating'
  }, {
    value: '15+',
    label: 'Classes/Week'
  }];
  return <section className="py-24 bg-yoga-warm relative" data-id="element-375">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-376">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-377">
          <FadeIn data-id="element-378">
            <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm block mb-2" data-id="element-379">
              Why Choose Us
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-yoga-dark mb-6" data-id="element-380">
              More than just a fitness studio
            </h2>
            <p className="text-lg text-yoga-muted" data-id="element-381">
              At Shree Yoga Fitness, we provide an authentic, supportive
              environment where traditional yoga meets modern wellness needs.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-382">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 100} data-id="element-383">
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group hover:-translate-y-1 border border-transparent hover:border-yoga-lightest h-full" data-id="element-384">
                <div className="w-16 h-16 bg-yoga-lightest text-yoga-primary rounded-xl flex items-center justify-center mb-6 group-hover:bg-yoga-primary group-hover:text-white transition-colors duration-300" data-id="element-385">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-yoga-dark mb-3" data-id="element-386">
                  {benefit.title}
                </h3>
                <p className="text-yoga-muted leading-relaxed" data-id="element-387">
                  {benefit.description}
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* Stats Row */}
        <div className="bg-yoga-dark rounded-3xl p-10 md:p-16 relative overflow-hidden" data-id="element-388">
          {/* Decorative background pattern */}
          <div className="absolute inset-0 opacity-10" data-id="element-389">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-390">
              <defs data-id="element-391">
                <pattern id="pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-392">
                  <circle cx="2" cy="2" r="2" fill="#fc6803" data-id="element-393" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#pattern)" data-id="element-394" />
            </svg>
          </div>

          <div className="relative z-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-395">
            {stats.map((stat, index) => <FadeIn key={index} delay={index * 100} data-id="element-396">
                <div className="flex flex-col items-center" data-id="element-397">
                  <span className="text-4xl md:text-5xl font-bold text-yoga-primary mb-2" data-id="element-398">
                    {stat.value}
                  </span>
                  <span className="text-white/80 font-medium" data-id="element-399">
                    {stat.label}
                  </span>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}